import Card from "../UI/Card";
import { ReactSelect } from "../UI/Select";
import { TVA_RATES } from "../../utils/constants/compta";
import Callout from "../UI/Callout";
import TextInput from "../UI/TextInput";
import Checkbox from "../UI/Checkbox";
import ButtonCard from "../UI/ButtonCard";
import { Interrogation, Trash } from "../UI/Icons";
import Button from "../UI/Button";
import Tooltip from "../UI/Tooltip";
import { FieldArray, useFormikContext } from "formik";
import styles from "./FieldArrayAutreCharge.module.css";
import useDependentField, {
  usePropertyExtractor,
} from "../../hooks/use-dependent-field";
import { AutreAppelCategorie } from "../../utils/constants/tenants";

const CATEGORIE_OPTIONS = [
  { value: AutreAppelCategorie.AUTRE_CHARGE, label: "Autre charge" },
  { value: AutreAppelCategorie.TAXE_FONCIERE, label: "Taxe foncière" },
  { value: AutreAppelCategorie.TOEM, label: "Taxe d'ordure ménagère" },
];

// Les catégories à libellé imposé n'affichent pas le champ Description :
// le libellé enregistré est celui de la catégorie.
function labelForCategorie(categorie) {
  if (categorie === AutreAppelCategorie.AUTRE_CHARGE) return "";
  return CATEGORIE_OPTIONS.find((o) => o.value === categorie)?.label ?? "";
}

export default function FieldArrayAutreCharge({ dependon }) {
  const { values, setFieldValue } = useFormikContext();
  useDependentField(
    "autre_appel",
    dependon,
    usePropertyExtractor("autre_appel"),
  );
  return (
    <FieldArray
      name="autre_appel"
      render={(arrayHelpers) => (
        <div>
          {values.autre_appel.length > 0 && (
            <Callout variant="warning">
              Les appels de charges spécifiques sont des charges hors forfait ou
              provision, qui doivent faire l'objet d'une ligne séparée sur la
              quittance ou l'avis d'échéance.
            </Callout>
          )}
          {values.autre_appel.map((item, index) => (
            <Card padding={"md"} key={index} className={"marginB10"}>
              <div className="gridColWrap240">
                <ReactSelect
                  name={`autre_appel[${index}].categorie`}
                  options={CATEGORIE_OPTIONS}
                  placeholder="Catégorie"
                  isClearable={false}
                  onChange={(option) =>
                    setFieldValue(
                      `autre_appel[${index}].label`,
                      labelForCategorie(option?.value),
                    )
                  }
                />
                {item.categorie === AutreAppelCategorie.AUTRE_CHARGE && (
                  <TextInput
                    name={`autre_appel[${index}].label`}
                    placeholder="Description"
                  />
                )}
                <TextInput
                  name={`autre_appel[${index}].montant`}
                  type="number"
                  placeholder="400"
                  unit={"€"}
                  step={"0.01"}
                />
              </div>
              <div className={"flex align-items-center space-between"}>
                <div className={"flex align-items-center wrap gap10"}>
                  <Checkbox
                    name={`autre_appel[${index}].tva`}
                    className={"marginB10"}
                  >
                    Charge soumise à la TVA
                  </Checkbox>
                  {item.tva && (
                    <ReactSelect
                      name={`autre_appel[${index}].taux_tva`}
                      placeholder="Taux global"
                      options={TVA_RATES}
                      className={styles.tauxSelect}
                    />
                  )}
                  <Checkbox
                    name={`autre_appel[${index}].remboursement`}
                    className={"marginB10"}
                  >
                    Il s'agit d'un remboursement
                    <Tooltip content="Cela force le montant en positif et génère un appel remboursement">
                      <Interrogation />
                    </Tooltip>
                  </Checkbox>
                </div>
                <ButtonCard onClick={() => arrayHelpers.remove(index)}>
                  <Trash />
                </ButtonCard>
              </div>
            </Card>
          ))}
          <Button
            className={"marginB10"}
            variant="tertiary"
            type="button"
            onClick={() =>
              arrayHelpers.push({
                categorie: AutreAppelCategorie.AUTRE_CHARGE,
                label: "",
                montant: "",
                tva: false,
                remboursement: false,
              })
            }
          >
            + Ajouter un appel de charge spécifique
          </Button>
        </div>
      )}
    />
  );
}
